import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { calculateEmissionsRoadMaintenanceActivities } from '../../Utils/moduleCalculates';
import { handleKeyDown } from '../../Utils/KeyboardHandlers';
import { EmissionsRoadMaintenanceActivities } from '../../../../../../services/types/CalculatorTransportRoads';
import { Modal } from '../../../../../../shared/components';
import EmissionsRoadMaintenanceActivitiesDetails from './Details/EmissionsRoadMaintenanceActivitiesDetails';

import CalculatorTableWrapper from '../Shared/CalculatorTableWrapper';

interface Props {
  emissionsRoadMaintenanceActivities: EmissionsRoadMaintenanceActivities;
  onUpdateEmissionsRoadMaintenanceActivities: (
    updatedEmissionsRoadMaintenanceActivities: EmissionsRoadMaintenanceActivities
  ) => void;
}

const EmissionsRoadMaintenanceActivitiesSection: React.FC<Props> = ({
  emissionsRoadMaintenanceActivities,
  onUpdateEmissionsRoadMaintenanceActivities,
}) => {
  const { t } = useTranslation();

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [totalCarbonSum, setTotalCarbonSum] = useState<number | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const areaNew = Number(emissionsRoadMaintenanceActivities.area);

    if (areaNew > 0) {
      const emissionFactor = emissionsRoadMaintenanceActivities.factorValue;
      const result = calculateEmissionsRoadMaintenanceActivities(emissionFactor, areaNew);

      setTotalCarbonSum(result);
    }
  }, [emissionsRoadMaintenanceActivities.area]);

  const handleInputArea = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    if (value.length > 10) {
      return;
    }

    const numericValue = value === '' ? null : Number(value);

    onUpdateEmissionsRoadMaintenanceActivities({
      ...emissionsRoadMaintenanceActivities,
      area: numericValue,
      subTotal:
        numericValue !== null
          ? calculateEmissionsRoadMaintenanceActivities(
              emissionsRoadMaintenanceActivities.factorValue,
              numericValue
            )
          : null,
    });

    setTotalCarbonSum(
      numericValue !== null
        ? calculateEmissionsRoadMaintenanceActivities(
            emissionsRoadMaintenanceActivities.factorValue,
            numericValue
          )
        : null
    );
  };

  return (
    <>
      <div className="row calculator-input-row">
        <div className="col-12 col-sm-5 col-md-3 col-lg-3">
          <label className="col-form-label mr-2" htmlFor="sector">
            {t('Total Area of Roads Maintained')}
          </label>
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-lg-2">
          <input
            ref={inputRef}
            type="number"
            id="arearoadInput"
            name="areaInput"
            value={
              emissionsRoadMaintenanceActivities.area !== null
                ? emissionsRoadMaintenanceActivities.area
                : ''
            }
            min="0"
            max={99999999.99}
            maxLength={10}
            className="calculator-input"
            onChange={handleInputArea}
            title="Total Area of Roads Maintained"
            onKeyDown={handleKeyDown}
          />
        </div>
      </div>

      <CalculatorTableWrapper
        totalCarbonSum={totalCarbonSum}
        onShowDetailsModal={() => setShowDetailsModal(true)}
        subtotalColSpan={3}
        colGroup={
          <colgroup>
            <col style={{ width: '40%' }} />
            <col style={{ width: '25%' }} />
            <col style={{ width: '25%' }} />
            <col style={{ width: '10%' }} />
          </colgroup>
        }
      />
      <Modal
        title={emissionsRoadMaintenanceActivities.name}
        visible={showDetailsModal}
        setVisible={() => setShowDetailsModal(false)}
        actions={[{ text: 'Close', action: () => setShowDetailsModal(false) }]}
        customClass="extra_wide-modal"
        onClosed={() => setShowDetailsModal(false)}
      >
        <div className="mb-0 table-responsive">
          <EmissionsRoadMaintenanceActivitiesDetails
            emissionsRoadMaintenanceActivities={emissionsRoadMaintenanceActivities}
          />
        </div>
      </Modal>
    </>
  );
};

export default EmissionsRoadMaintenanceActivitiesSection;
